@if (imputationByDate()?.length) {
  <div class="relative flex justify-center">
    <canvas class="w-full" #hoursBalanceChart></canvas>
  </div>
} @else {
  <p class="my-0 text-center" i18n>No hay horas imputadas</p>
}
